import React, { useContext } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { ThemeContext } from 'styled-components';
import { Container } from './styles';

const ScreenLoader: React.FC = () => {
  const { colors } = useContext(ThemeContext);
  return (
    <Container>
      <ClipLoader size={50} color={colors.primary} loading />
    </Container>
  );
};

export default ScreenLoader;
